import _ from 'lodash';
import moment from 'moment';
import React, { useCallback, useContext, useMemo, useRef, useState } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { generateClient } from '@aws-amplify/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as icons_solid from '@fortawesome/free-solid-svg-icons';
import { getAgentSettings as _getAgentSettings, getSubjectContacts } from '@/graphql/queries';
import { launchAgent as _launchAgent } from '@/graphql/mutations';
import TranscriptModal from '@/TranscriptModal';
import { outcome_color } from '@/utils';

const client = generateClient();

const recordingIcon = (<FontAwesomeIcon className="fg-purple" icon={icons_solid.faVolumeLow} size="lg" />);
const transcriptIcon = (<FontAwesomeIcon className="fg-purple" icon={icons_solid.faQuoteLeft} size="lg" />);

export default ({ subject_id }) => {
	const isConstructed = useRef(false);
	const [busy, setBusy] = useState({});
	const updateBusy = useCallback((id, value) => {
		setBusy(prevState => ({ ...prevState, [id]: value }));
	}, []);
	const [contacts, setContacts] = useState();
	const [modal, setModal] = useState();

	if (!isConstructed.current) {
		isConstructed.current = true;
		updateBusy('contacts', true);
		client.graphql({ query: getSubjectContacts, variables: { sorting: { field: 'started_at', order: 'desc' }, subject_id } })
			.then(response => {
				setContacts(response.data.getSubjectContacts.subject_contacts || []);
				updateBusy('contacts', false);
			});
	}

	const contacts_el = useMemo(() => {
		if (!contacts) return busy.contacts ? (
			<div className="text-center" style={{marginBottom:'2rem',marginTop:'2rem'}}>
				<button className="btn btn-primary" type="button" disabled>
					<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
					Loading...
				</button>
			</div>
		) : undefined;
		const contacts_el = contacts.map((e, i) => {
			const started_at = moment(e.started_at).format('M/DD/YY h:mm A');
			const onClose = () => {
				setModal();
			};
			const onClick = ({ autoplay = false } = {}) => setModal(<TranscriptModal autoplay={autoplay} id={e.contact_id} onClose={onClose} />);
			let d;
			if (e.duration_seconds) {
				const _d = moment.duration(e.duration_seconds, 'seconds');
				const h = Math.floor(_d.asHours());
				const m = _d.minutes();
				const s = _d.seconds();
				d = `${h > 0 ? String(h).padStart(2, '0') + ':' : ''}${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
			}
			return (
				<div className="row mb-4 g-0" key={i}>
					<div className="row mb-1 g-0">
						<div className="col"><b>{started_at}</b>&nbsp;{d}&nbsp;&ndash;&nbsp;{e.contact_id}</div>
						{e.recording_url && <div className="col-auto ms-2 btn-link cursor-pointer" onClick={() => onClick({ autoplay: true })}>{recordingIcon}</div>}
						<div className="col-auto ms-2 btn-link cursor-pointer" onClick={onClick}>{transcriptIcon}</div>
					</div>
					{e.summary && (
						<div className="border rounded-3 p-2 bg-light-purple text-break">
							<Markdown
								children={e.summary}
								remarkPlugins={[remarkGfm, remarkBreaks]}
								components={{
								ul: ({ node, ...props }) => (
									<ul style={{ margin: 0, paddingLeft: '1.25rem' }} {...props} />
								),
								h1: 'h3',
								h2: 'h4',
								h3: 'h4',
								a: (props) => <a {...props} target="_blank" rel="noopener noreferrer" />,
								code: ({ inline, children }) =>
									!inline ? (
									<pre style={{ background: "#f6f8fa", padding: "0.75rem", borderRadius: "6px" }}>
										<code>{children}</code>
									</pre>
									) : (
									<code style={{ background: "#eee", padding: "0.2rem 0.4rem", borderRadius: "4px" }}>{children}</code>
									)
								}}
							/>
						</div>
					)}
					{(e.outcomes || []).map((outcome, i) => <span className={`col-auto mt-2 me-2 p-2 badge ${outcome_color(outcome)}`} key={i}>{outcome}</span>)}
				</div>
			)
		});
		return contacts_el;
	}, [JSON.stringify(busy)]);

	return (
		<>
			{modal}
			{contacts_el && (
				<div className="mb-4">
					{contacts_el}
				</div>
			)}
		</>
	);
};
